import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import AiFormUpdateProd from './AiFormUpdateProd'; // Newer SDK version
import AiFormUpdateProdHeygenAPI from './AiFormUpdateProdHeygenAPI'; // Older SDK version


export default function AiFormUpdateProdWrapper() {
    const [useNewerSDK, setUseNewerSDK] = useState(true); // Default to newer version
    const [loading, setLoading] = useState(true);
    const { client_url } = useParams();

    useEffect(() => {
        const fetchSDKPreference = async () => {
            try {
                const response = await fetch(`/auth/aiform/frontend/${client_url}`);

                if (!response.ok) {
                    console.error('Failed to fetch AI form data');
                    setLoading(false);
                    return;
                }

                const data = await response.json();
                const aiFormData = data?.aiForms?.[0];

                // Check if useNewerHeyGenSDK is defined, default to true if not
                const sdkPreference = aiFormData?.useNewerHeyGenSDK !== undefined
                    ? aiFormData.useNewerHeyGenSDK
                    : true;

                setUseNewerSDK(sdkPreference);
                setLoading(false);

                console.log('HeyGen SDK Version:', sdkPreference ? 'Newer (LiveAvatar SDK)' : 'Older (Streaming API)');
            } catch (error) {
                console.error('Error fetching SDK preference:', error);
                // Default to newer version on error
                setUseNewerSDK(true);
                setLoading(false);
            }
        };

        if (client_url) {
            fetchSDKPreference();
        }
    }, [client_url]);


    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                fontSize: '18px',
                color: '#666'
            }}>
                Loading...
            </div>
        );
    }

    // Conditionally render the appropriate component based on SDK preference
    return useNewerSDK ? <AiFormUpdateProd /> : <AiFormUpdateProdHeygenAPI />;
}
